/* Noor cart helper.
   1. Any add-to-cart form that carries a chosen subscription (a filled selling_plan input) is
      submitted by this script with the plan included, then the customer is taken to the cart.
      The theme's own add-to-cart code only sends the variant and quantity, which is why a chosen
      plan never reached checkout before.
   2. Forms marked data-noor-add (homepage quick add) are submitted in place and show "Added".
   3. Plan toggles ([data-noor-plan]) write the chosen plan into their form and relabel the button.
   Safe to include more than once; it only initialises one time. */
(function () {
  if (window.__noorCart) return;
  window.__noorCart = true;

  var COUNT_SEL = '.cart-count, .cart_count, .cart-count-bubble, #CartCount, .cartCount, [data-cart-count], .cart-count-number';

  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll(COUNT_SEL).forEach(function (el) { el.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('noor:cart-updated', { detail: c }));
      })
      .catch(function () {});
  }

  function addFromForm(form) {
    var fd = new FormData(form);
    var item = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
    var plan = fd.get('selling_plan');
    if (plan) item.selling_plan = plan;
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().then(function (j) { throw new Error(j.description || j.message || ('Error ' + r.status)); });
    });
  }

  function submitButton(form) {
    return form.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
  }

  // Runs in the capture phase so it wins over the theme's own submit handlers.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !window.fetch) return;
    var action = (form.getAttribute('action') || '');
    if (action.indexOf('/cart/add') === -1) return;

    var planInput = form.querySelector('input[name="selling_plan"]');
    var hasPlan = !!(planInput && planInput.value);
    var quick = form.hasAttribute('data-noor-add');
    if (!hasPlan && !quick) return; // leave the theme's normal behaviour alone

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    var btn = submitButton(form);
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); if (quick) btn.textContent = form.getAttribute('data-noor-adding') || 'Adding…'; }

    addFromForm(form).then(function () {
      if (hasPlan || form.getAttribute('data-noor-after') === 'cart') {
        window.location.href = '/cart';
        return;
      }
      refreshCount();
      if (btn) {
        btn.textContent = form.getAttribute('data-noor-added') || 'Added ✓';
        btn.classList.add('is-added');
        setTimeout(function () { btn.innerHTML = label; btn.classList.remove('is-added'); btn.disabled = false; btn.removeAttribute('aria-busy'); }, 2200);
      }
    }).catch(function (err) {
      if (btn) { btn.innerHTML = label; btn.disabled = false; btn.removeAttribute('aria-busy'); }
      window.alert(err && err.message ? err.message : 'Sorry, that could not be added to the cart.');
    });
  }, true);

  // Plan toggles: one-time vs subscribe inside a form.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-noor-plan] input[type="radio"]')) return;
    var box = input.closest('[data-noor-plan]');
    var form = box.closest('form');
    var hidden = (form || box).querySelector('input[name="selling_plan"]');
    if (hidden) hidden.value = input.value || '';
    box.querySelectorAll('.noor-plan__opt').forEach(function (l) { l.classList.toggle('is-active', l.contains(input)); });
    var btn = form ? submitButton(form) : null;
    var lbl = input.getAttribute('data-label');
    if (btn && lbl) { var span = btn.querySelector('span') || btn; span.textContent = lbl; }
  });
})();
